// Get the event target value
export function GetEleValue(evt: Event)
{
    return (<HTMLInputElement>evt.target)?.value;
}

// Get the event target value
export function GetCheckboxEleValue(evt: Event): boolean
{
    const inputEle = <HTMLInputElement>evt.target;
    if ("checkbox" !== inputEle.type)
    {
        alert("This isn't a checkbox")
        return false;
    }

    return inputEle.checked;
}